import Vue from 'vue'
const state = {
}//title: key: router:
  // getters
const getters = {
	getState: state => {		
    	return state;
  },
  getKeys:state => {
 		return state.key;
  }
}  // actions
const actions = {   //异步
  getState({commit},arg) { // commit 提交；name即为点击后传递过来的参数  	
    return	commit ('getState',arg);
	},
	setItem({commit},Items){
		 return	commit ('getState',Items);
	},
	setOneItem({commit},Item){
		return	commit ('setOneItem',Item);
	}
}// mutations
const mutations = {
    getState (state, arg) { 
    	for(let k in arg){
    		  Vue.set(state, k, arg[k]);
    	}     	
    	for(let k in state){
    		  if(arg[k]==undefined){    		  	
    		  	Vue.set(state, k, null);
    		  }
    	} 
    },
    setOneItem(state,item){
    	for(let k in state){
    		if(item[k]!==undefined && state[k]!==undefined){
    			Vue.set(state, k, item[k]);
    		}    		 
    	}
    }
}
  
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/routekey.js